import React from "react"
import Comment from "./comment"

const VISIBLE_COMMENTS = 3

class CommentsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAll: false
    }
  }

  showAllComments = (e) => {
    this.setState({
      showAll: true
    })
    e.preventDefault();
  }

  render() {
    const { comments, onLikeUpOrDown, hasLikes, isWinner, siteUrl } = this.props
    const { showAll } = this.state

    return (
      <div className="suggestions">
        <p>Top comments:</p>
        { comments.map( (comment, index) => (
          <Comment
            data={comment}
            siteUrl={siteUrl}
            key={`comment-${index}`}
            onLikeUpOrDown={ onLikeUpOrDown }
            hasLikes={ hasLikes }
            isHidden={ !showAll && index + 1 > VISIBLE_COMMENTS && !isWinner} />
        ))}
        {
          (!showAll && comments.length > VISIBLE_COMMENTS && !isWinner) ? (
            <button onClick= { this.showAllComments } class="view-more">View {comments.length - VISIBLE_COMMENTS} More Comments</button>
          )
          : null
        }
        
      </div>
    )
  }
}

export default CommentsList
